class ApiConnector {

    constructor(axios) {
        this.axios = axios;
    }

    async get(params) {
        // console.log(params)
        let self = this;
        let response = await self.axios.get(`${params.option}.json`)
        let result = await response.data
        
        /*
        * Filtro por pagina
        */
        if(params.page) {
            result.data = result.data.filter(e => e.nPage === params.page)
        }

        /*
        * Borrar elemento
        */ 
        
        if(params.action === 'remove') {
            // console.log(params.item.id)
            if(params.item.id%2===0){
                return {remove: false, msg: 'Registro eliminado!'}
            }
            return {remove: true, msg: 'No se pudo eliminar el registro!'}
        }

        /*
        * Buscar elemento por id
        */ 

        if(params.action === 'update') {
            // console.log(result.data)
            // console.log(params.item)
            result.data = result.data.filter(e => e.id === params.item)
            return result;
        }

        return result;
    }
}

export default ApiConnector;